import React from 'react'
import { HistoryRouter } from './components/router/HistoryRouter'

import { AllContextInjector } from './data/AllContextInjector'
import { UserProvider } from './data/UserContext'
import { UnitsProvider } from './data/UnitsContext'
import { RoutesHandler } from './components/RoutesHandler'
import { FromProvider } from './data/FromContext'
import { GenericStorageProvider } from './data/GenericStorageContext'
import { history } from './utils/history'

const providers = [UserProvider, FromProvider, GenericStorageProvider, UnitsProvider]

export function App() {
  return (
    <div className="App">
      <HistoryRouter history={history}>
        <AllContextInjector providers={providers}>
          <RoutesHandler />
        </AllContextInjector>
      </HistoryRouter>
    </div>
  )
}
